<template>
    <div class="ts-finder__capability-filter">
        <ul class="ts-finder__capability-filter-list ts-finder__capability-filter-list--level-1">
            <li v-for="(filter, index) in serverCapabilityFilters" :key="index" class="ts-finder__capability-filter-item ts-finder__capability-filter-item--level-1">
                <CapabilityCheckbox :filter="filter" level="1" v-on:changed="level1Changed" />
                <button class="ts-finder__capability-filter-list-toggle" @click="toggleChildren" v-if="filter.children"><i class="fas fa-angle-down ts-finder__capability-filter-list-toggle-icon"></i></button>
                <ul class="ts-finder__capability-filter-list ts-finder__capability-filter-list--level-2" v-if="filter.children">
                    <li v-for="(child, index) in filter.children" :key="index" class="ts-finder__capability-filter-item ts-finder__capability-filter-item--level-2">
                        <CapabilityCheckbox :filter="child" level="2" />
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</template>

<script>
    import CapabilityCheckbox from './CapabilityCheckbox.vue';
    import { mapState } from 'vuex'
    import $ from 'jQuery'

    export default {
        computed: {
            ...mapState([
                'serverCapabilityFilters'
            ])
        },
        components: {
            CapabilityCheckbox
        },
        methods: {
            toggleChildren(event) {
                if (event) {
                    $(event.target)
                        .closest('button') //find the actual button (the event.target might be the icon inside the button)
                        .toggleClass('active') //toggle button active
                        .closest('li')
                        .find('ul')
                        .slideToggle(); //then run the slide animation on it
                }
            },
            level1Changed(args) {
                if (args.target && args.checked) {
                    $(args.target)
                        .closest('li')
                        .find('button') //find the actual button (the event.target might be the icon inside the button)
                        .addClass('active') //toggle button active
                        .closest('li')
                        .find('ul')
                        .slideDown(); //then run the slide animation on it
                }
            }
        }
    };
</script>